import * as Sentry from '@sentry/nextjs';

interface SentryErrorProps {
  error: unknown;
  extra?: Record<string, any>;
  source: string;
}

export const sendSentryError = ({
  error,
  extra = {},
  source,
}: SentryErrorProps) => {
  Sentry.captureException(error, {
    extra,
    tags: {
      source,
      alertType: 'slack-notify',
    },
    level: 'error',
  });
};
